if (!customElements.get('x-swiper')) {
  class XSwiper extends HTMLElement {
    constructor() {
      super();

      if (typeof Swiper === 'undefined') {
        console.error('Swiper is not defined. Unable to initialize XSwiper');
        return;
      }

      if (!this.classList.contains('swiper')) {
        this.classList.add('swiper');
      }

      this.slidesPerView = this.dataset.slidesPerView ? parseInt(this.dataset.slidesPerView, 10) : 'auto';
      this.maxSlides = this.dataset.maxSlides ? parseInt(this.dataset.maxSlides, 10) : false;
      this.initialSlidesCount = this.querySelectorAll('.swiper-slide').length;
      this.mobileSpaceBetween = this.dataset.mobileSpaceBetween ? parseInt(this.dataset.mobileSpaceBetween, 10) : 16;

      if (this.maxSlides && this.slidesPerView === 'auto') {
        this.slidesPerView = Math.min(this.maxSlides, this.initialSlidesCount);
      }

      this.swiper = null;
      this.swiperWrapper = this.querySelector('.swiper-wrapper');
      this.nextButton = this.querySelector('.swiper-button-next');
      this.prevButton = this.querySelector('.swiper-button-prev');
    }

    connectedCallback() {
      this.initSwiper();
      this.scrollToSelected();
    }

    initSwiper() {
      this.swiper = new Swiper(this, {
        slidesPerView: this.slidesPerView, //this.slidesPerView === 'auto' ? 'auto' : Math.max(3, this.slidesPerView - 1)
        slidesPerGroup: this.slidesPerView === 'auto' ? 1 : this.slidesPerView,
        spaceBetween: this.mobileSpaceBetween,
        mousewheel: true,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        breakpoints: {
          749: {
            spaceBetween: 16,
          },
        },
        init: false,
      });

      this.swiper.on('lock', this.onLock.bind(this));
      this.swiper.on('unlock', this.onUnlock.bind(this));

      this.swiper.init();
    }

    scrollToSelected() {
      if (!this.swiper) {
        return;
      }

      const selectedIndex = this.swiper.slides.findIndex((slide) => {
        const radioInput = slide.querySelectorAll('input[type="radio"]');
        const activeClass = slide.classList.contains('active');

        return (radioInput.length === 1 && radioInput[0].checked) || activeClass;
      });

      this.swiper.slideTo(selectedIndex, 0);
    }

    onLock() {
      this.classList.add('swiper-locked');
    }

    onUnlock() {
      this.classList.remove('swiper-locked');
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }

  customElements.define('x-swiper', XSwiper);
}
